var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-menu',{staticClass:"el-menu-demo",attrs:{"default-active":_vm.defaultActive,"mode":"horizontal"},on:{"select":_vm.handleSelect}},_vm._l((_vm.tabs),function(tab,index){return _c('el-menu-item',{key:tab.name,attrs:{"index":tab.name}},[_vm._v(_vm._s(tab.name))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }